module.exports = __webpack_public_path__ + "img/case-logo-53.315301f9.png";